/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { TagType } from "../enums";
export const tagSchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  parent: z.lazy(() => tagSchema).nullish(),
  parentId: z.string().uuid().nullish(),
  type: z.nativeEnum(TagType).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type Tag = z.infer<typeof tagSchema>;
